import { useRef } from "react";

import { isAPIError } from "@/core/services";

export const novaChave = () =>
  globalThis.crypto?.randomUUID?.() ??
  `${Date.now().toString(36)}-${Math.random().toString(36).slice(2)}`;

export function useChaveIdempotencia() {
  const atual = useRef<{ assinatura: string; chave: string } | null>(null);

  async function comChave<T>(payload: unknown, enviar: (chave: string) => Promise<T>): Promise<T> {
    const assinatura = JSON.stringify(payload);
    if (atual.current?.assinatura !== assinatura)
      atual.current = { assinatura, chave: novaChave() };
    try {
      const resposta = await enviar(atual.current.chave);
      atual.current = null;
      return resposta;
    } catch (erro) {
      if (isAPIError(erro) && erro.status >= 400 && erro.status < 500 && erro.status !== 408) {
        atual.current = null;
      }
      throw erro;
    }
  }

  return { comChave };
}
